import React from "react";
import TBGallery from "../../../photoGallery/TBGallery";
import TBGalleryTwo from "../../../photoGallery/TBGalleryTwo";
import Image2 from "../../../../assets/gallery/latestProjects/GiulioAndVictoria/2.webp";
import Image3 from "../../../../assets/gallery/latestProjects/GiulioAndVictoria/3.webp";
import Image4 from "../../../../assets/gallery/latestProjects/GiulioAndVictoria/4.webp";
import Image5 from "../../../../assets/gallery/latestProjects/GiulioAndVictoria/5.webp";
import Image6 from "../../../../assets/gallery/latestProjects/GiulioAndVictoria/6.webp";
import Image7 from "../../../../assets/gallery/latestProjects/GiulioAndVictoria/7.webp";
import Image8 from "../../../../assets/gallery/latestProjects/GiulioAndVictoria/8.webp";
import Image9 from "../../../../assets/gallery/latestProjects/GiulioAndVictoria/9.webp";
import Image10 from "../../../../assets/gallery/latestProjects/GiulioAndVictoria/10.webp";
import { ProjectDetails } from "./ProjectDetails";
import "../../projectStyling/style.css";
import Footer from "../../../Footer";

const GiulioAndVictoria = () => {
  const galleryImages = [
    {
      img: Image2,
    },
    {
      img: Image3,
    },
    {
      img: Image4,
    },
  ];
  const galleryImagesTwo = [
    {
      img: Image5,
    },
    {
      img: Image6,
    },
    {
      img: Image7,
    },
    {
      img: Image8,
    },
    {
      img: Image9,
    },
    {
      img: Image10,
    },
  ];
  return (
    <>
      <br />
      <div>
        <ProjectDetails />
      </div>
      <br />
      <div>
        <TBGallery galleryImages={galleryImages} />
        <TBGalleryTwo galleryImagesTwo={galleryImagesTwo} />
      </div>
      <div>
        <Footer />
      </div>
    </>
  );
};

export default GiulioAndVictoria;
